import { JsonObject, JsonProperty } from 'json2typescript';
import { DateConverter, NumberToStringConverter, NullToFalseBooleanConverter } from './converters';
import AggregatorModel from './AggregatorModel';
import { PRICE_MODEL } from '../const/app';

@JsonObject('HotelFareModel')
export default class HotelFareModel {
  @JsonProperty('id', NumberToStringConverter) public id:string = undefined;
  @JsonProperty('price', Number) public price:number = -1;
  @JsonProperty('currency', String) public currency:string = '';
  @JsonProperty('breakfast', NullToFalseBooleanConverter, true) public breakfast:boolean = false;
  @JsonProperty('comfort_class', String, true) public comfortClass:string = '';
  @JsonProperty('refundable_until', DateConverter, true) public refundableUntil:Date = undefined;
  @JsonProperty('room_type', String, true) public roomType:string = '';
  @JsonProperty('conditions', String, true) public conditions:string = '';
  @JsonProperty('selected', Boolean, true) public selected:boolean = false;
  @JsonProperty('payment_type', String, true) public paymentType:string = '';
  @JsonProperty('negotiated_rate', Boolean) public negotiatedRate:boolean= false;
  @JsonProperty('provider', String) public provider:string= undefined;
  @JsonProperty('room_details', String) public roomDetails:string= undefined;
  @JsonProperty('breakfast_surcharge', Number) public breakfastSurcharge:number = undefined;
  @JsonProperty('breakfast_surcharge_currency', String)
  public breakfastSurchargeCurrency:string = undefined;
  @JsonProperty('deeplink', String, true) public deepLink: string = undefined;
  @JsonProperty('co2_in_kg', Number, true) public co2InKg: number = -1;
  @JsonProperty('sort_value', String, true) public sortValue: String = undefined;
  @JsonProperty('aggregator', AggregatorModel, true) aggregator: AggregatorModel = undefined;
  @JsonProperty('compliant', Boolean, true) public compliant: boolean = true;
  @JsonProperty('price_model', String, true) public priceModel: string = undefined;
  @JsonProperty('monthly_price', Number, true) public monthlyPrice: number = undefined;

  // TEMPORARY (#14675): eligible for FlexLane (Koala CFAR), which derp shows as a FLEXLANE badge so
  // the team can confirm in staging that eligibility lands on the right rates. A flight or train
  // carries the same marker in its fare name instead - a hotel rate's only name is room_type, and
  // HotelFaresList groups rates by it and builds the room-type filter from its distinct values.
  // Delete with the badge once the real design ships.
  @JsonProperty('flexlane', Boolean, true) public flexlane: boolean = false;

  get isMonthlyEstimate(): boolean {
    return this.priceModel === PRICE_MODEL.MONTHLY_AVERAGE && !!this.monthlyPrice;
  }
}
